import Utils from "../../Utils";

export default class Navigation {

    static initializeEvents() {
        // Navigation repliée avec bouton d'action
        Array
            .from(document.querySelectorAll('.navigation-with-button .navigation-button'))
            .forEach(button => {
                button.addEventListener('click', event => {
                    event.preventDefault();

                    button.parentNode.classList.toggle('active');
                    button.parentNode.setAttribute('aria-expanded', button.parentNode.classList.contains('active'));
                });
            });

        // Navigation classique
        Array
            .from(document.querySelectorAll('.navigation button'))
            .forEach(button => {
                button.addEventListener('click', event => {
                    event.preventDefault();

                    /** @type {HTMLUListElement} */
                    const targetNavigationList = button.nextElementSibling;
                    if (targetNavigationList.classList.contains('hidden')) {
                        Array
                            .from(event.currentTarget.parentNode.parentNode.children)
                            .forEach(item => {
                                const list = item.querySelector('ul');
                                if (list) {
                                    list.classList.add('hidden');
                                }
                            });

                        targetNavigationList.classList.remove('hidden');
                        event.currentTarget.setAttribute('aria-expanded', 'false');
                    } else {
                        targetNavigationList.classList.add('hidden');
                        event.currentTarget.setAttribute('aria-expanded', 'true');
                    }
                });
            });

        Array
            .from(document.querySelectorAll('.navigation a[href^="#"]'))
            .forEach(link => {
                link.addEventListener('click', event => {
                    const currentLink = event.target;
                    const targetElementId = currentLink.getAttribute('href').substring(1);
                    const targetElement = document.getElementById(targetElementId);

                    Array
                        .from(Utils.parent(currentLink, '.navigation').querySelectorAll('.active'))
                        .forEach(item => item.classList.remove('active'));

                    currentLink.parentNode.classList.add('active');

                    const focusOutHandler = event => {
                        event.target.removeAttribute('tabindex');
                        event.target.removeEventListener('focusout', focusOutHandler);
                    };

                    targetElement.setAttribute('tabindex', '0');
                    targetElement.addEventListener('focusout', focusOutHandler);
                    targetElement.focus();
                });
            });
    }

}